import React, { useState, useEffect, useMemo } from 'react';
import { Alert, FlatList, ScrollView, Touchable, TouchableOpacity, View } from 'react-native'

import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import Icon from '@/components/IcomoonIcon';
import api from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import DateSelector from '@/components/Forms/DateSelector';
import { useNavigation } from '@react-navigation/native';

import dayjs from 'dayjs'
import { Image } from 'expo-image';




function CommunityRow({ community, onPress }) {
  return (
    <TouchableOpacity
      style={tw`py-2 bg-white rounded-2xl border border-gray-200 mx-4 mb-4`}
      onPress={onPress}
    >
      <View style={tw`row justify-between items-start px-4 pt-1 pb-1`}>
        <View style={tw`flex-1 row`}>
          {
            community.image_path &&
            <Image source={community.image_path} style={tw`h-10 w-10 rounded-xl mr-2`} />
          }

          <Text style={tw`text-secondary font-500`}>{community.name}</Text>
        </View>

        <View style={tw`self-center`}>
          <Icon name='chevron-right' color={tw.color('secondary')} />
        </View>
      </View>
    </TouchableOpacity>
  )
}


const budget = [{"concepto":"Control de Acceso","monthly_budget":[{"ingreso":317728.62,"operacion":368377.05,"diferencia":-50648.43},{"ingreso":332686.26,"operacion":402937.05,"diferencia":-70250.79},{"ingreso":340950.75,"operacion":368377.05,"diferencia":-27426.30},{"ingreso":345000.00,"operacion":362000.00,"diferencia":-17000.00},{"ingreso":350000.00,"operacion":355000.00,"diferencia":-5000.00},{"ingreso":353831.64,"operacion":364597.05,"diferencia":-10765.41},{"ingreso":355000.00,"operacion":360000.00,"diferencia":-5000.00},{"ingreso":352000.00,"operacion":358000.00,"diferencia":-6000.00},{"ingreso":350500.00,"operacion":353000.00,"diferencia":-2500.00},{"ingreso":348000.00,"operacion":355000.00,"diferencia":-7000.00},{"ingreso":349000.00,"operacion":352000.00,"diferencia":-3000.00},{"ingreso":351000.00,"operacion":350000.00,"diferencia":1000.00}]},
{ "concepto": "Manto de Conjunto", "monthly_budget": [{ "ingreso": 160115.28, "operacion": 136636.16, "diferencia": 23479.12 }, { "ingreso": 167688.30, "operacion": 139645.16, "diferencia": 28043.14 }, { "ingreso": 171835.83, "operacion": 164645.16, "diferencia": 7190.27 }, { "ingreso": 172000.00, "operacion": 165000.00, "diferencia": 7000.00 }, { "ingreso": 174000.00, "operacion": 160000.00, "diferencia": 14000.00 }, { "ingreso": 178326.59, "operacion": 118973.96, "diferencia": 59352.63 }, { "ingreso": 176000.00, "operacion": 150000.00, "diferencia": 26000.00 }, { "ingreso": 173500.00, "operacion": 158000.00, "diferencia": 15500.00 }, { "ingreso": 172000.00, "operacion": 155000.00, "diferencia": 17000.00 }, { "ingreso": 170000.00, "operacion": 159000.00, "diferencia": 11000.00 }, { "ingreso": 168000.00, "operacion": 157000.00, "diferencia": 11000.00 }, { "ingreso": 165000.00, "operacion": 160000.00, "diferencia": 5000.00 }] },
{ "concepto": "Operación Casa Club", "monthly_budget": [{ "ingreso": 222000.00, "operacion": 271327.02, "diferencia": -49327.02 }, { "ingreso": 232500.00, "operacion": 278098.00, "diferencia": -45598.00 }, { "ingreso": 238250.00, "operacion": 264636.50, "diferencia": -26386.50 }, { "ingreso": 240000.00, "operacion": 250000.00, "diferencia": -10000.00 }, { "ingreso": 242000.00, "operacion": 245000.00, "diferencia": -3000.00 }, { "ingreso": 247250.00, "operacion": 292809.00, "diferencia": -45559.00 }, { "ingreso": 246000.00, "operacion": 248000.00, "diferencia": -2000.00 }, { "ingreso": 243000.00, "operacion": 245000.00, "diferencia": -2000.00 }, { "ingreso": 241000.00, "operacion": 243000.00, "diferencia": -2000.00 }, { "ingreso": 240000.00, "operacion": 240000.00, "diferencia": 0.00 }, { "ingreso": 239000.00, "operacion": 238000.00, "diferencia": 1000.00 }, { "ingreso": 237000.00, "operacion": 235000.00, "diferencia": 2000.00 }] },
{ "concepto": "Manto de Condominio", "monthly_budget": [{ "ingreso": 147816.48, "operacion": 101735.38, "diferencia": 46101.10 }, { "ingreso": 153000.80, "operacion": 126883.45, "diferencia": 26117.35 }, { "ingreso": 156250.00, "operacion": 140000.00, "diferencia": 16250.00 }, { "ingreso": 157000.00, "operacion": 145000.00, "diferencia": 12000.00 }, { "ingreso": 159000.00, "operacion": 146000.00, "diferencia": 13000.00 }, { "ingreso": 164628.94, "operacion": 131708.90, "diferencia": 32920.04 }, { "ingreso": 161000.00, "operacion": 135000.00, "diferencia": 26000.00 }, { "ingreso": 158000.00, "operacion": 132000.00, "diferencia": 26000.00 }, { "ingreso": 156000.00, "operacion": 130000.00, "diferencia": 26000.00 }, { "ingreso": 154000.00, "operacion": 128000.00, "diferencia": 26000.00 }, { "ingreso": 152000.00, "operacion": 126000.00, "diferencia": 26000.00 }, { "ingreso": 150000.00, "operacion": 124000.00, "diferencia": 26000.00 }] },
{ "concepto": "Administración Proveedor", "monthly_budget": [{ "ingreso": 98399.28, "operacion": 129000.00, "diferencia": -30500.72 }, { "ingreso": 103053.00, "operacion": 129000.00, "diferencia": -25947.00 }, { "ingreso": 105601.93, "operacion": 128000.00, "diferencia": -22400.00 }, { "ingreso": 107000.00, "operacion": 128000.00, "diferencia": -21000.00 }, { "ingreso": 107500.00, "operacion": 127000.00, "diferencia": -19500.00 }, { "ingreso": 109591.09, "operacion": 129000.00, "diferencia": -19408.91 }, { "ingreso": 110000.00, "operacion": 128000.00, "diferencia": -18000.00 }, { "ingreso": 108000.00, "operacion": 127000.00, "diferencia": -19000.00 }, { "ingreso": 107000.00, "operacion": 126000.00, "diferencia": -19000.00 }, { "ingreso": 106000.00, "operacion": 125000.00, "diferencia": -19000.00 }, { "ingreso": 105000.00, "operacion": 124000.00, "diferencia": -19000.00 }, { "ingreso": 104000.00, "operacion": 123000.00, "diferencia": -19000.00 }] },
{ "concepto": "Administración de la AC", "monthly_budget": [{ "ingreso": 36212.64, "operacion": 36212.26, "diferencia": 0.38 }, { "ingreso": 37925.40, "operacion": 36618.26, "diferencia": 1307.14 }, { "ingreso": 38863.34, "operacion": 6710.16, "diferencia": 32153.18 }, { "ingreso": 39000.00, "operacion": 38500.00, "diferencia": 500.00 }, { "ingreso": 39500.00, "operacion": 39000.00, "diferencia": 500.00 }, { "ingreso": 40331.42, "operacion": 37500.26, "diferencia": 2831.16 }, { "ingreso": 40500.00, "operacion": 38000.00, "diferencia": 2500.00 }, { "ingreso": 40200.00, "operacion": 37800.00, "diferencia": 2400.00 }, { "ingreso": 39900.00, "operacion": 37500.00, "diferencia": 2400.00 }, { "ingreso": 39600.00, "operacion": 37200.00, "diferencia": 2400.00 }, { "ingreso": 39300.00, "operacion": 36900.00, "diferencia": 2400.00 }, { "ingreso": 39000.00, "operacion": 36600.00, "diferencia": 2400.00 }] }]


// Datos resumidos por mes
// const summaryData = [
//   { month: "Enero", total_presupuesto: 982274.32, total_operacion: 1043291.47, diferencia: -130517.15 },
//   { month: "Febrero", total_presupuesto: 1028698.55, total_operacion: 1113176.28, diferencia: -124477.73 },
//   { month: "Marzo", total_presupuesto: 1054179.13, total_operacion: 1155036.94, diferencia: -120857.81 },
//   { month: "Abril", total_presupuesto: 1060871.67, total_operacion: 1130415.18, diferencia: -69543.51 },
//   { month: "Mayo", total_presupuesto: 1072332.14, total_operacion: 1145126.92, diferencia: -73294.78 },
//   { month: "Junio", total_presupuesto: 1093959.68, total_operacion: 1074589.17, diferencia: 75733.32 },
//   { month: "Julio", total_presupuesto: 1100432.23, total_operacion: 1080725.64, diferencia: 19706.59 },
//   { month: "Agosto", total_presupuesto: 1085472.15, total_operacion: 1102134.79, diferencia: -16662.64 },
//   { month: "Septiembre", total_presupuesto: 1112196.78, total_operacion: 1128053.45, diferencia: -15856.67 },
//   { month: "Octubre", total_presupuesto: 1130089.61, total_operacion: 1150053.97, diferencia: -19964.36 },
//   { month: "Noviembre", total_presupuesto: 1145072.03, total_operacion: 1130011.76, diferencia: 15060.27 },
//   { month: "Diciembre", total_presupuesto: 1170231.84, total_operacion: 1180029.56, diferencia: -9797.72 }
// ];


const BudgetCard = ({ month, total_presupuesto, total_operacion, diferencia, onPress }) => {
  const isNegative = diferencia < 0;

  const monthsStr = [ "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre" ];


  const formatNumber = num =>
    `$${num.toLocaleString('en-US', { minimumFractionDigits: 0 })}`;

  return (
    <TouchableOpacity style={tw`bg-white p-4 rounded-lg mb-4 shadow`} onPress={onPress}>
      <Text style={tw`text-lg font-bold mb-2`}>{monthsStr[month-1]}</Text>
      <Text>💰 Ingreso: <Text style={tw`font-semibold`}>{formatNumber(total_presupuesto)}</Text></Text>
      <Text>📋 Operación: <Text style={tw`font-semibold`}>{formatNumber(total_operacion)}</Text></Text>
      <Text>
        📉 Diferencia:{' '}
        <Text style={tw`${isNegative ? 'text-red-600' : 'text-green-600'} font-semibold`}>
          {formatNumber(diferencia)} {isNegative ? '🔻' : '🔺'}
        </Text>
      </Text>
    </TouchableOpacity>
  );
};

const MonthlyBudget = ({ budgets, selectedMonth }) => {
  console.log({ budgets, selectedMonth })
  
  return (
    <View style={tw`p-4`}>
      {budgets?.map((item, idx) => (
        <View key={idx} style={tw`mb-4 p-4 bg-white rounded shadow`}>
          <Text style={tw`text-base font-bold mb-2`}>{item.expense_type.name}</Text>

          <View style={tw`flex-row justify-between`}>
            <Text style={tw`text-gray-600`}>💰 Ingreso:</Text>
            <Text style={tw`font-semibold`}>
              ${item.overview_by_month[selectedMonth].total_presupuesto.toLocaleString('en-US')}
            </Text>
          </View>

          <View style={tw`flex-row justify-between`}>
            <Text style={tw`text-gray-600`}>📋 Operación:</Text>
            <Text style={tw`font-semibold`}>
              ${item.overview_by_month[selectedMonth].total_operacion.toLocaleString('en-US')}
            </Text>
          </View>

          <View style={tw`flex-row justify-between`}>
            <Text style={tw`text-gray-600`}>📉 Diferencia:</Text>
            <Text
              style={tw`font-semibold ${item.overview_by_month[selectedMonth].diferencia < 0 ? 'text-red-600' : 'text-green-600'
                }`}
            >
              ${item.overview_by_month[selectedMonth].diferencia.toLocaleString('en-US')}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
};


export default function CommunitiesScreen({ }) {
  const [selectedCommunity, setSelectedCommunity] = useState();

  const { isInitialLoading, error, data: communities, refetch } = useQuery({
    queryKey: ['vinte.communities'],
    queryFn: () => api.get(`/vinte/communities?`).then(response => response.data),
  })

  const { data: communityBudgets } = useQuery({
    queryKey: ['vinte.community.budgets', selectedCommunity?.uuid],
    queryFn: () => api.get(`/vinte/communities/${selectedCommunity?.uuid}/budgets`).then(response => response.data),
    enabled: !!selectedCommunity,
  })

  const [showMonth, setShowMonth] = useState(null);



  
  return (
    <View style={tw`row flex-1 h-full gap-x-4`}>
      <View style={tw`w-[300px] h-full px-3 py-3 bg-white rounded-xl`}>
        {
          communities?.length == 0 &&
          <Text style={tw`mt-25 text-lg text-center text-gray-400`}>Sin desarrollos registrados</Text>
        }

        <FlatList
          data={communities}
          contentContainerStyle={tw`pt-2 pb-14`}
          renderItem={({ item }) => <CommunityRow onPress={() => setSelectedCommunity(item)} community={item} />}
          keyExtractor={(item) => item.uuid}
        />
      </View>

      {
        (selectedCommunity) &&
          <View style={tw` h-full px-3 py-3 bg-white rounded-xl`}>
            {/* {
                selectedCommunity.dashboard.budget.map(budget =>
                  <View style={tw``}>
                    <Text>{budget.name}</Text>
                  </View>
                )
              } */}
            <ScrollView style={tw`p-4 bg-gray-100`}>
              {/* <Text style={tw`text-xl font-bold mb-4 text-center`}>🏡 Residencial El Roble</Text> */}
              {communityBudgets?.year_overview?.map((item, idx) => (
                <BudgetCard key={idx} {...item} onPress={() => setShowMonth(idx)} />
              ))}
            </ScrollView>
          </View>
      }

      {
        (showMonth !== null) &&
          <View style={tw`flex-1 h-full px-3 py-3 bg-white rounded-xl`}>
            <MonthlyBudget
              budgets={communityBudgets.budgets}
              selectedMonth={showMonth}
            />
          </View>
      }
    </View>
  )
}